export function drawRoundRect(
  ctx: CanvasRenderingContext2D,
  x: number,
  y: number,
  width: number,
  height: number,
  cornarRadius: number = 0
) {
  ctx.beginPath();
  ctx.moveTo(x + cornarRadius, y);
  ctx.lineTo(x + width - cornarRadius, y);
  if (cornarRadius > 0) ctx.quadraticCurveTo(x + width, y, x + width, y + cornarRadius);
  ctx.lineTo(x + width, y + height - cornarRadius);
  if (cornarRadius > 0) ctx.quadraticCurveTo(x + width, y + height, x + width - cornarRadius, y + height);
  ctx.lineTo(x + cornarRadius, y + height);
  if (cornarRadius > 0) ctx.quadraticCurveTo(x, y + height, x, y + height - cornarRadius);
  ctx.lineTo(x, y + cornarRadius);
  if (cornarRadius > 0) ctx.quadraticCurveTo(x, y, x + cornarRadius, y);
  ctx.closePath();
  ctx.fill();
  ctx.stroke();
}
